export const PatentLink = Symbol('PatentLink');

/**
 * 打开专利的服务
 */
export interface PatentLink {
    /**
     * 获取专利链接
     * @param patentId 专利ID
     * @returns 专利链接
     */
    getPatentLink(patentId: string): string;
}

